import getEnvConfig from "@efcloud/el-b2b-get-env-config"
import deepmerge from "deepmerge"

export default deepmerge({
  "studentStatus": "/api/student-status/v1",
  "GAPStudentStatus": "/gap/bff/api/v1/common/bootstrap"
}, getEnvConfig("endpoints"))
